import { KilnStatusModel } from '@app/models/KilnStatusModel';
import { KilnStatusRepository } from '@app/repositories/KilnStatusRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class KilnStatusService extends ServiceBase<KilnStatusModel, KilnStatusRepository<KilnStatusModel>> {
    public constructor() {
        super(new KilnStatusRepository());
    }
}
